module.exports = __webpack_public_path__ + "img/over.0c664464.png";